import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  IconButton,
  Typography,
  Button,
  Stack,
  SvgIcon,
} from "@mui/material";
import ButtonCeci from "./ButtonCeci";
import "../AppMobileXS.css";

export default function MenuDrawer({ open, onClose }) {

  const bgColor = "#869CA6"
  const linkInstagram = "https://www.instagram.com/studio_ginnastica_posturale/"
  const linkFacebook = "https://www.facebook.com/p/Studio-Ginnastica-Posturale-100089142420608/?ref=1"
  const [hover, setHover] = useState(0)
  const [btnClicked, setBtnClicked] = useState("")

  useEffect( () => {
    if (hover != 0) {
      setTimeout(() => {
        setHover(0)
      }, 100)
    }
  }, [hover])

  function isClicked(link) {
    return { color: link == btnClicked ? "white" :  "#CBD4D9"}
  } 

  function setClicked(link) {
    setBtnClicked(link)
    onClose();
    const el = document.getElementById(link);
    if (el) {
        el.scrollIntoView({ behavior: "smooth" });
    }
  }


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: 400,
            width: "80%",
            backgroundColor: bgColor,
            color: "#C3D0D2",
            borderRadius: "0 0 0 20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }
        }
      }}
    >
      {/* Header con logo e pulsante chiudi */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#FEFCFB",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingY: '20px',

        }}
      >
        <div style={{
          borderRadius: "50px",
          backdropFilter: "blur(10.588233947753906px)",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          background: "linear-gradient(180deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.10) 100%)",
          marginLeft: 20
        }}>
          <img
            src="/assets/LogoAzzurro.svg" // sostituisci con il tuo logo
            alt="Logo"
            style={{
              height: "50px",
              padding: "10px 15px",
            }}
          />
        </div>
        <IconButton onClick={onClose} sx={{ color: bgColor, marginRight: 3 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <rect width="25.7718" height="2.97367" rx="1.48683" transform="matrix(0.70079 0.713368 -0.70079 0.713368 2.08386 0)" fill="#527180" />
            <rect width="25.7718" height="2.97367" rx="1.48683" transform="matrix(0.70079 -0.713368 0.70079 0.713368 0 18.3848)" fill="#527180" />
          </svg>
        </IconButton>
      </Box>

      {/* Voci menu */}
      <Box sx={{ p: 4 }}>
        <Stack spacing={3}>
          <div className="stile-sottotitolo2" 
            style={{cursor: "pointer", ...isClicked("title")}}
            onClick={() => setClicked("title")}
          >Home</div>
          <div className="stile-sottotitolo2" 
            style={{cursor: "pointer", ...isClicked("presentazione")}}
            onClick={() => setClicked("presentazione")}
          >Mi presento</div>
          <div className="stile-sottotitolo2" 
            style={{cursor: "pointer", ...isClicked("cosa-faremo")}}
            onClick={() => setClicked("cosa-faremo")}
          >Cosa faremo</div>
          <div className="stile-sottotitolo2" 
            style={{cursor: "pointer", ...isClicked("quando-rivolgersi")}}
            onClick={() => setClicked("quando-rivolgersi")}
          >
            Quando rivolgersi a me
          </div>
        </Stack>

        <Box sx={{ mt: 5 }}>
          <ButtonCeci onClick={() => {
              setClicked("contatti")
              
            }} > Contattami </ButtonCeci>
        </Box>
      </Box>

      {/* Footer */}
      <Box sx={{ px: 4, pt: 2, flexGrow: 1 }}>
        <Typography
          sx={{
            color: "#FFFFFF",
            fontFamily: "Barlow",
            fontSize: "1.2rem",
            mb: 1,
          }}
        >
          Troviamoci sui social!
        </Typography>
        <Stack direction="row" >
          <IconButton onClick={() => { 
              setHover(1)
              window.open(linkInstagram) 
            }}>
            <SvgIcon sx={{ width: 60, height: 60, cursor: "pointer"  }} viewBox="0 0 57 57" >
              {hover == 1 ? 
                <path d="M28.5 19.9615C26.8113 19.9615 25.1604 20.4623 23.7563 21.4005C22.3521 22.3387 21.2577 23.6723 20.6115 25.2325C19.9652 26.7927 19.7961 28.5095 20.1256 30.1658C20.4551 31.8221 21.2683 33.3435 22.4624 34.5376C23.6565 35.7317 25.1779 36.5449 26.8342 36.8744C28.4905 37.2039 30.2073 37.0348 31.7675 36.3885C33.3277 35.7423 34.6613 34.6479 35.5995 33.2437C36.5377 31.8396 37.0385 30.1887 37.0385 28.5C37.0361 26.2362 36.1358 24.0658 34.535 22.465C32.9342 20.8642 30.7638 19.9639 28.5 19.9615ZM28.5 34.1923C27.3742 34.1923 26.2736 33.8585 25.3375 33.233C24.4014 32.6075 23.6718 31.7185 23.241 30.6784C22.8102 29.6382 22.6974 28.4937 22.9171 27.3895C23.1367 26.2853 23.6788 25.271 24.4749 24.4749C25.271 23.6788 26.2853 23.1367 27.3895 22.9171C28.4937 22.6974 29.6382 22.8102 30.6784 23.241C31.7185 23.6718 32.6075 24.4014 33.233 25.3375C33.8585 26.2736 34.1923 27.3742 34.1923 28.5C34.1923 30.0097 33.5926 31.4576 32.5251 32.5251C31.4576 33.5926 30.0097 34.1923 28.5 34.1923ZM37.0385 10H19.9615C17.3204 10.0028 14.7883 11.0532 12.9208 12.9208C11.0532 14.7883 10.0028 17.3204 10 19.9615V37.0385C10.0028 39.6796 11.0532 42.2117 12.9208 44.0792C14.7883 45.9468 17.3204 46.9972 19.9615 47H37.0385C39.6796 46.9972 42.2117 45.9468 44.0792 44.0792C45.9468 42.2117 46.9972 39.6796 47 37.0385V19.9615C46.9972 17.3204 45.9468 14.7883 44.0792 12.9208C42.2117 11.0532 39.6796 10.0028 37.0385 10ZM44.1538 37.0385C44.1538 38.9256 43.4042 40.7354 42.0698 42.0698C40.7354 43.4042 38.9256 44.1538 37.0385 44.1538H19.9615C18.0744 44.1538 16.2646 43.4042 14.9302 42.0698C13.5958 40.7354 12.8462 38.9256 12.8462 37.0385V19.9615C12.8462 18.0744 13.5958 16.2646 14.9302 14.9302C16.2646 13.5958 18.0744 12.8462 19.9615 12.8462H37.0385C38.9256 12.8462 40.7354 13.5958 42.0698 14.9302C43.4042 16.2646 44.1538 18.0744 44.1538 19.9615V37.0385ZM39.8846 19.25C39.8846 19.6722 39.7594 20.0849 39.5249 20.4359C39.2903 20.787 38.9569 21.0606 38.5669 21.2221C38.1768 21.3837 37.7476 21.426 37.3336 21.3436C36.9195 21.2612 36.5391 21.0579 36.2406 20.7594C35.9421 20.4609 35.7388 20.0805 35.6564 19.6664C35.574 19.2524 35.6163 18.8232 35.7779 18.4331C35.9394 18.0431 36.213 17.7097 36.5641 17.4751C36.9151 17.2406 37.3278 17.1154 37.75 17.1154C38.3161 17.1154 38.8591 17.3403 39.2594 17.7406C39.6597 18.1409 39.8846 18.6839 39.8846 19.25Z" fill="white" />
                : 
                <path d="M28.5 19.9615C26.8113 19.9615 25.1604 20.4623 23.7563 21.4005C22.3521 22.3387 21.2577 23.6723 20.6115 25.2325C19.9652 26.7927 19.7961 28.5095 20.1256 30.1658C20.4551 31.8221 21.2683 33.3435 22.4624 34.5376C23.6565 35.7317 25.1779 36.5449 26.8342 36.8744C28.4905 37.2039 30.2073 37.0348 31.7675 36.3885C33.3277 35.7423 34.6613 34.6479 35.5995 33.2437C36.5377 31.8396 37.0385 30.1887 37.0385 28.5C37.0361 26.2362 36.1358 24.0658 34.535 22.465C32.9342 20.8642 30.7638 19.9639 28.5 19.9615ZM28.5 34.1923C27.3742 34.1923 26.2736 33.8585 25.3375 33.233C24.4014 32.6075 23.6718 31.7185 23.241 30.6784C22.8102 29.6382 22.6974 28.4937 22.9171 27.3895C23.1367 26.2853 23.6788 25.271 24.4749 24.4749C25.271 23.6788 26.2853 23.1367 27.3895 22.9171C28.4937 22.6974 29.6382 22.8102 30.6784 23.241C31.7185 23.6718 32.6075 24.4014 33.233 25.3375C33.8585 26.2736 34.1923 27.3742 34.1923 28.5C34.1923 30.0097 33.5926 31.4576 32.5251 32.5251C31.4576 33.5926 30.0097 34.1923 28.5 34.1923ZM37.0385 10H19.9615C17.3204 10.0028 14.7883 11.0532 12.9208 12.9208C11.0532 14.7883 10.0028 17.3204 10 19.9615V37.0385C10.0028 39.6796 11.0532 42.2117 12.9208 44.0792C14.7883 45.9468 17.3204 46.9972 19.9615 47H37.0385C39.6796 46.9972 42.2117 45.9468 44.0792 44.0792C45.9468 42.2117 46.9972 39.6796 47 37.0385V19.9615C46.9972 17.3204 45.9468 14.7883 44.0792 12.9208C42.2117 11.0532 39.6796 10.0028 37.0385 10ZM44.1538 37.0385C44.1538 38.9256 43.4042 40.7354 42.0698 42.0698C40.7354 43.4042 38.9256 44.1538 37.0385 44.1538H19.9615C18.0744 44.1538 16.2646 43.4042 14.9302 42.0698C13.5958 40.7354 12.8462 38.9256 12.8462 37.0385V19.9615C12.8462 18.0744 13.5958 16.2646 14.9302 14.9302C16.2646 13.5958 18.0744 12.8462 19.9615 12.8462H37.0385C38.9256 12.8462 40.7354 13.5958 42.0698 14.9302C43.4042 16.2646 44.1538 18.0744 44.1538 19.9615V37.0385ZM39.8846 19.25C39.8846 19.6722 39.7594 20.0849 39.5249 20.4359C39.2903 20.787 38.9569 21.0606 38.5669 21.2221C38.1768 21.3837 37.7476 21.426 37.3336 21.3436C36.9195 21.2612 36.5391 21.0579 36.2406 20.7594C35.9421 20.4609 35.7388 20.0805 35.6564 19.6664C35.574 19.2524 35.6163 18.8232 35.7779 18.4331C35.9394 18.0431 36.213 17.7097 36.5641 17.4751C36.9151 17.2406 37.3278 17.1154 37.75 17.1154C38.3161 17.1154 38.8591 17.3403 39.2594 17.7406C39.6597 18.1409 39.8846 18.6839 39.8846 19.25Z" fill="#CBD4D9" />
              }
            </SvgIcon>
          </IconButton>
          <IconButton onClick={() => { 
              setHover(2)
              window.open(linkFacebook) 
            }}>
            <SvgIcon sx={{ width: 60, height: 60, cursor: "pointer" }} viewBox="0 0 57 57" >
              {hover == 2 ?
                <path d="M28.5 10C24.8411 10 21.2643 11.085 18.222 13.1178C15.1796 15.1506 12.8085 18.0399 11.4082 21.4204C10.008 24.8008 9.64165 28.5205 10.3555 32.1092C11.0693 35.6978 12.8313 38.9942 15.4185 41.5815C18.0058 44.1687 21.3022 45.9307 24.8908 46.6445C28.4795 47.3583 32.1992 46.992 35.5796 45.5918C38.9601 44.1915 41.8494 41.8204 43.8822 38.778C45.915 35.7357 47 32.159 47 28.5C46.9948 23.5951 45.0441 18.8925 41.5758 15.4242C38.1075 11.9559 33.4049 10.0052 28.5 10ZM29.9231 44.088V32.7692H34.1923C34.5697 32.7692 34.9317 32.6193 35.1986 32.3524C35.4655 32.0855 35.6154 31.7236 35.6154 31.3461C35.6154 30.9687 35.4655 30.6068 35.1986 30.3399C34.9317 30.073 34.5697 29.9231 34.1923 29.9231H29.9231V25.6538C29.9231 24.899 30.2229 24.1751 30.7567 23.6413C31.2905 23.1076 32.0144 22.8077 32.7692 22.8077H35.6154C35.9928 22.8077 36.3548 22.6578 36.6217 22.3909C36.8885 22.124 37.0385 21.762 37.0385 21.3846C37.0385 21.0072 36.8885 20.6452 36.6217 20.3783C36.3548 20.1115 35.9928 19.9615 35.6154 19.9615H32.7692C31.2595 19.9615 29.8117 20.5613 28.7442 21.6288C27.6767 22.6963 27.0769 24.1441 27.0769 25.6538V29.9231H22.8077C22.4303 29.9231 22.0683 30.073 21.8014 30.3399C21.5346 30.6068 21.3846 30.9687 21.3846 31.3461C21.3846 31.7236 21.5346 32.0855 21.8014 32.3524C22.0683 32.6193 22.4303 32.7692 22.8077 32.7692H27.0769V44.088C23.0653 43.7218 19.3492 41.8232 16.7017 38.787C14.0542 35.7508 12.6791 31.8109 12.8624 27.7867C13.0457 23.7626 14.7733 19.9639 17.6858 17.181C20.5984 14.3981 24.4717 12.8452 28.5 12.8452C32.5283 12.8452 36.4016 14.3981 39.3142 17.181C42.2267 19.9639 43.9543 23.7626 44.1376 27.7867C44.3209 31.8109 42.9458 35.7508 40.2983 38.787C37.6508 41.8232 33.9347 43.7218 29.9231 44.088Z" fill="white" />
                :
                <path d="M28.5 10C24.8411 10 21.2643 11.085 18.222 13.1178C15.1796 15.1506 12.8085 18.0399 11.4082 21.4204C10.008 24.8008 9.64165 28.5205 10.3555 32.1092C11.0693 35.6978 12.8313 38.9942 15.4185 41.5815C18.0058 44.1687 21.3022 45.9307 24.8908 46.6445C28.4795 47.3583 32.1992 46.992 35.5796 45.5918C38.9601 44.1915 41.8494 41.8204 43.8822 38.778C45.915 35.7357 47 32.159 47 28.5C46.9948 23.5951 45.0441 18.8925 41.5758 15.4242C38.1075 11.9559 33.4049 10.0052 28.5 10ZM29.9231 44.088V32.7692H34.1923C34.5697 32.7692 34.9317 32.6193 35.1986 32.3524C35.4655 32.0855 35.6154 31.7236 35.6154 31.3461C35.6154 30.9687 35.4655 30.6068 35.1986 30.3399C34.9317 30.073 34.5697 29.9231 34.1923 29.9231H29.9231V25.6538C29.9231 24.899 30.2229 24.1751 30.7567 23.6413C31.2905 23.1076 32.0144 22.8077 32.7692 22.8077H35.6154C35.9928 22.8077 36.3548 22.6578 36.6217 22.3909C36.8885 22.124 37.0385 21.762 37.0385 21.3846C37.0385 21.0072 36.8885 20.6452 36.6217 20.3783C36.3548 20.1115 35.9928 19.9615 35.6154 19.9615H32.7692C31.2595 19.9615 29.8117 20.5613 28.7442 21.6288C27.6767 22.6963 27.0769 24.1441 27.0769 25.6538V29.9231H22.8077C22.4303 29.9231 22.0683 30.073 21.8014 30.3399C21.5346 30.6068 21.3846 30.9687 21.3846 31.3461C21.3846 31.7236 21.5346 32.0855 21.8014 32.3524C22.0683 32.6193 22.4303 32.7692 22.8077 32.7692H27.0769V44.088C23.0653 43.7218 19.3492 41.8232 16.7017 38.787C14.0542 35.7508 12.6791 31.8109 12.8624 27.7867C13.0457 23.7626 14.7733 19.9639 17.6858 17.181C20.5984 14.3981 24.4717 12.8452 28.5 12.8452C32.5283 12.8452 36.4016 14.3981 39.3142 17.181C42.2267 19.9639 43.9543 23.7626 44.1376 27.7867C44.3209 31.8109 42.9458 35.7508 40.2983 38.787C37.6508 41.8232 33.9347 43.7218 29.9231 44.088Z" fill="#CBD4D9" />                
              }
            </SvgIcon></IconButton>
        </Stack>
      </Box>
    </Drawer>
  );
}
